import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "language-selector",
  templateUrl: "./language-selector.component.html",
  styleUrls: ["./language-selector.component.scss"]
})
export class LanguageSelectorComponent {
  availableLanguages: string[];

  @Input() label = "Language";
  @Input() labelClasses!: string;
  @Input() labelStyles?: string;

  @Input() inputClasses?: string;
  @Input() inputStyles?: string;

  @Output() languageChange = new EventEmitter<string>();

  constructor(public translateService: TranslateService) {
    this.availableLanguages = this.translateService.getLangs();
  }

  onLanguageChange(selectedLanguage: string): void {
    this.translateService.use(selectedLanguage);

    this.languageChange.emit(selectedLanguage);
  }
}
